// extracted by mini-css-extract-plugin
module.exports = {"root":"_30WOO","section":"_1mH7Q","carouselContainer":"_wm8J","bottomTextWrapper":"_3RyaP","bottomTitle":"_2uIsb","link":"_1zmKp","errorMessage":"_1SFGj"};